module.exports = __webpack_public_path__ + "img/slider_galery_20.fe0aa42f.jpg";